import {getConfig} from '../helper'
import basecolorways from '../config/colorways/basecolorways'
import _ from 'lodash'

const configStore = {
  state: {
    config: {},
    configLoaded: false
  },
  actions: {
    async refreshConfig (context, payload) {
      let result = await getConfig(
        {
          'facility_name': payload.facility_name
        }
        )
      context.commit('updateConfig', result)
    }
  },
  getters: {
    chillerType (state) {
      // generic, air-cooled 2 circuits
      return _.get(state.config,'chiller type', 'generic water-cooled')
    },
    faultEquipType (state) {
      return _.get(state.config,'faultEquipType', null)
    },
    activateExternalViewRepository (state) {
      return _.get(state.config,'activateExternalViewRepository', null)
    },
      siteConfigMaster (state) {
          return _.get(state.config,'siteConfigMaster', null)
      },
      mappingConfigMaster (state) {
          return _.get(state.config,'mappingConfigMaster', null)
      },
      managedFacilities(state) {
          return _.get(state.config, 'managedFacilities', null)
      },
      facilityClusterMap(state) {
          return _.get(state.config, 'facilityClusterMap', null)
      },
      managedNamespaces(state) {
          return _.get(state.config, 'managedNamespaces', null)
      },
      hideFddToolbar(state) {
          return _.get(state.config, 'hideFddToolbar', false)
      },
      siteConfigChildren(state) {
          return _.get(state.config, 'siteConfigChildren', null)
      },
    menuConfig (state) {
      let menuConfig=_.get(state.config, 'menuConfig', null)
      if(menuConfig&&menuConfig!==""){
        return JSON.parse(menuConfig)
      } else {
        return null
      }
    },
    mobileMenuConfig (state) {
      let mobileMenuConfig=_.get(state.config, 'mobileMenuConfig', null)
      if(!mobileMenuConfig){
        let menuConfig=_.get(state.config, 'menuConfig', null)
        if(menuConfig&&menuConfig!==""){
          let firstUsable = JSON.parse(menuConfig).filter(x=>x.to)[0]
          if (firstUsable){
            mobileMenuConfig=JSON.stringify([firstUsable])
          }
        }
      }
      if(mobileMenuConfig&&mobileMenuConfig!==""){
        return JSON.parse(mobileMenuConfig)
      } else {
        return null
      }
    },
      mappingIntegrityConfig(state) {
          let integrityC = _.get(state.config, 'mappingIntegrityConfig', null)
          let integritySections = _.get(state.config, 'mappingIntegritySections', null)
          if (integrityC && integrityC !== "") {
              let parsed = JSON.parse(integrityC)
              if (integritySections && integritySections !== "") {
                  let activeSections=integritySections.split(",")
                  parsed=parsed.filter(x=>!x.section||x.section.split(",").some(item=>activeSections.includes(item)))
              } else {
                  parsed=parsed.filter(x=>!x.section)
              }
              return parsed
          } else {
              return null
          }
      },
      mappingCalculatedConfig (state) {
          let integrityC=_.get(state.config, 'mappingCalculatedConfig', null)
          if(integrityC&&integrityC!==""){
              return JSON.parse(integrityC)
          } else {
              return null
          }
      },
      mappingRefConfig (state) {
          let integrityC=_.get(state.config, 'mappingRefConfig', null)
          if(integrityC&&integrityC!==""){
              return JSON.parse(integrityC)
          } else {
              return null
          }
      },
      chartColorways (state) {
          let colorways=_.get(state.config, 'chartColorways', null)
          if(colorways&&colorways!==""){
              return JSON.parse(colorways)
          } else {
              return JSON.parse(JSON.stringify(basecolorways))
          }
      },
      hiddenPointsConfig (state) {
          let integrityC=_.get(state.config, 'hiddenPointsConfig', null)
          if(integrityC&&integrityC!==""){
              return JSON.parse(integrityC)
          } else {
              return null
          }
      },
      themeOverride (state) {
          let theme=_.get(state.config, 'themeOverride', null)
          if(theme&&theme!==""){
              return JSON.parse(theme)
          } else {
              return null
          }
      },
    coolingLoadUnit (state) {
      return _.get(state.config,'coolingLoadUnit', 'kW')
    },
    factors (state) {
      return [_.get(state.config,'temperature_coef_for_power', 2.2343),_.get(state.config,'intercept_coef_for_power', 3.868)]
    },
    anomalyEquipType (state) {
      return _.get(state.config,'anomalyEquipType', null)
    },
    totalLicensedPoints (state) {
      return _.get(state.config, 'LICENSE_POINTS_TOTAL', null)
    },
    chillerPowerVar (state) {
      return _.get(state.config,'Chiller Power Variable', 'Comp_Power')
    },
      alternativeLogoOverride (state) {
          return _.get(state.config,'alternativeLogoOverride', null)
      },
      secondaryLogoOverride (state) {
          return _.get(state.config,'secondaryLogoOverride', null)
      },
      brandNameOverride (state) {
          return _.get(state.config,'brandNameOverride', null)
      },
      maintenanceEndDate (state) {
          return _.get(state.config,'maintenanceEndDate', null)
      },
  },
  mutations: {
    updateConfig (state, payload) {
      let output = {}
      for (let i in payload.result) {
        output[payload.result[i].config_name] = payload.result[i].config
      }
      state.config = output
      state.facility_name = payload.facility_name
      state.configLoaded = true
    }
  }
}

export default configStore
